import { useState } from 'react';

const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const [keepData, setKeepData] = useState(null);
  const handlers = {
    on: (data) => {
      setState(true);
      setKeepData(data);
    },
    off: () => {
      setState(false);
      setKeepData(null);
    },
    toggle: () => {
      setState(!state);
      setKeepData(null);
    },
    reset: () => {
      setState(initialState);
      setKeepData(null);
    },
    setState,
  };

  return [state, handlers, keepData];
};

export default useToggle;
